import { useState } from 'react'
import type { FormEvent } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

function LoginPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const inviteToken = searchParams.get('platform_invite')

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  async function handleSubmit(
    event: FormEvent<HTMLFormElement>,
  ) {
    event.preventDefault()

    setError('')
    setLoading(true)

    try {
      const response = await fetch('/api/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email.trim(),
          password,
        }),
      })

      const data = await response.json()

      if (!response.ok) {
        setError(
          typeof data.detail === 'string'
            ? data.detail
            : 'Unable to sign in.',
        )
        return
      }

      localStorage.setItem(
        'aad_access_token',
        data.access_token,
      )
      if (inviteToken) {
        const accepted = await fetch('/api/auth/platform-staff-invitations/accept', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${data.access_token}` },
          body: JSON.stringify({ platform_invite_token: inviteToken }),
        })
        const acceptedData = await accepted.json()
        if (!accepted.ok) { setError(typeof acceptedData.detail === 'string' ? acceptedData.detail : 'Unable to accept invitation.'); return }
        localStorage.setItem('aad_access_token', acceptedData.access_token)
        navigate('/admin'); return
      }

      navigate('/dashboard')
    } catch {
      setError(
        'Unable to connect to the server. Please try again.',
      )
    } finally {
      setLoading(false)
    }
  }

  return (
    <main>
      <section>
        <h1>Sign in to AAD Business App</h1>

        <p>Access your business workspace.</p>

        <form onSubmit={handleSubmit}>
          <div>
            <label htmlFor="email">
              Email address
            </label>

            <input
              id="email"
              name="email"
              type="email"
              value={email}
              onChange={(event) =>
                setEmail(event.target.value)
              }
              autoComplete="email"
              required
            />
          </div>

          <div>
            <label htmlFor="password">
              Password
            </label>

            <input
              id="password"
              name="password"
              type="password"
              value={password}
              onChange={(event) =>
                setPassword(event.target.value)
              }
              autoComplete="current-password"
              required
            />
          </div>

          <button
            type="button"
            onClick={() =>
              navigate('/forgot-password')
            }
          >
            Forgot password?
          </button>

          {error && (
            <p role="alert">
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={loading}
          >
            {loading
              ? 'Signing in...'
              : 'Sign in'}
          </button>
        </form>

        <button
          type="button"
          onClick={() => navigate(inviteToken ? `/signup?platform_invite=${encodeURIComponent(inviteToken)}` : '/signup')}
        >
          Create an account
        </button>
      </section>
    </main>
  )
}

export default LoginPage
